// TrademarkPage.js

import React from "react";
import "../components/Styles/TrademarkPage.css";

import {
  FaStar,
  FaCheckCircle,
  FaWhatsapp,
  FaTrademark,
  FaUserShield,
  FaFileSignature,
  FaRegClock,
} from "react-icons/fa";

function TrademarkPage() {
  return (
    <div className="trademark-page">

      {/* HERO SECTION */}

      <section className="tm-hero">

        <div className="tm-overlay"></div>

        <div className="container">

          <div className="tm-wrapper">

            {/* LEFT */}

            <div className="tm-left">

              <div className="tm-rating">

                <FaStar />
                <span>4.5 Rating (1654 Reviews)</span>

              </div>

              <h1>
                Trademark <span>Registration</span>
              </h1>

              <p>
                Protect your brand identity with professional trademark
                registration services across India.
              </p>

              <div className="tm-users">
                2970+ People Purchased
              </div>

            </div>

            {/* RIGHT FORM */}

            <div className="tm-right">

              <div className="sticky-form">

                <h3>Get Free Consultation</h3>

                <input type="text" placeholder="Full Name" />

                <input type="email" placeholder="Email Address" />

                <input type="text" placeholder="Phone Number" />

                <textarea placeholder="Your Message"></textarea>

                <button>Submit Now</button>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* HOW IT WORKS */}

      <section className="tm-section">

        <div className="container">

          <div className="section-title">
            <h2>How It Works</h2>
          </div>

          <div className="work-grid">

            <div className="work-card">

              <span>01</span>

              <h3>Choose Product & Pay</h3>

              <p>
                Select your required trademark package and make payment.
              </p>

            </div>

            <div className="work-card">

              <span>02</span>

              <h3>Fill Required Details</h3>

              <p>
                Upload all required documents and provide trademark details.
              </p>

            </div>

            <div className="work-card">

              <span>03</span>

              <h3>Receive Updates</h3>

              <p>
                Get updates on WhatsApp and SMS regarding application progress.
              </p>

            </div>

            <div className="work-card">

              <span>04</span>

              <h3>Trademark Delivery</h3>

              <p>
                Get complete support till your trademark filing is completed.
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* WHAT IS TRADEMARK */}

      <section className="tm-info-section">

        <div className="container info-grid">

          <div className="info-content">

            <h2>What is a Trademark?</h2>

            <p>
              Trademark is a visual identity such as logo, symbol, brand
              name, signature or design that differentiates your products
              and services from others.
            </p>

            <ul>

              <li>
                <FaCheckCircle />
                Creates unique business identity
              </li>

              <li>
                <FaCheckCircle />
                Protects brand legally
              </li>

              <li>
                <FaCheckCircle />
                Builds customer trust
              </li>

            </ul>

          </div>

          <div className="info-image">

            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop"
              alt="trademark"
            />

          </div>

        </div>

      </section>

      {/* WHY IMPORTANT */}

      <section className="tm-section light-bg">

        <div className="container">

          <div className="section-title">
            <h2>Why Trademark Registration?</h2>
          </div>

          <div className="benefit-grid">

            <div className="benefit-card">

              <FaTrademark />

              <p>
                Helps in establishing unique identity for your business.
              </p>

            </div>

            <div className="benefit-card">

              <FaUserShield />

              <p>
                Protects your business from trademark infringement.
              </p>

            </div>

            <div className="benefit-card">

              <FaFileSignature />

              <p>
                Increases goodwill and company brand value.
              </p>

            </div>

            <div className="benefit-card">

              <FaRegClock />

              <p>
                Gives long term legal protection for your brand.
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* TRADEMARK PROCESS */}

      <section className="tm-section">

        <div className="container">

          <div className="section-title">
            <h2>Trademark Registration Process</h2>
          </div>

          <div className="process-grid">

            <div className="process-card">
              Preliminary Search for conflicting marks.
            </div>

            <div className="process-card">
              Preparing and filing trademark application.
            </div>

            <div className="process-card">
              Examination report review and reply.
            </div>

            <div className="process-card">
              Hearing before Trademark Registrar if required.
            </div>

          </div>

        </div>

      </section>

      {/* DOCUMENTS */}

      <section className="tm-section light-bg">

        <div className="container">

          <div className="section-title">

            <h2>
              Documents required for registering a Trademark
            </h2>

            <p>
              Listed below are the documents required for Trademark Registration
            </p>

          </div>

          <div className="doc-grid">

            <div className="doc-card">

              <h3>Proof of Applicant</h3>

              <p>
                PAN Card, Address Proof and Certificate of Registration.
              </p>

            </div>

            <div className="doc-card">

              <h3>Brand Name & Logo</h3>

              <p>
                Symbol or Logo of the Trademark to be registered.
              </p>

            </div>

            <div className="doc-card">

              <h3>User Affidavit</h3>

              <p>
                Required in case Trademark is already under use.
              </p>

            </div>

            <div className="doc-card">

              <h3>MSME Certificate</h3>

              <p>
                To avail rebate on Government Trademark fee.
              </p>

            </div>

            <div className="doc-card">

              <h3>Signed TM-48 Form</h3>

              <p>
                Allows Attorney to file Trademark on your behalf.
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* CHAT */}

      <section className="chat-section">

        <div className="container">

          <div className="chat-box">

            <div className="chat-content">

              <h2>Chat with us</h2>

              <p>
                Connect with our experts for all your trademark related needs.
              </p><div className="chat-features">

    <span>✔ Expert Lawyers</span>

    <span>✔ Fast Filing</span>

    <span>✔ WhatsApp Updates</span>

    <span>✔ PAN India Service</span>

  </div>



              <a
                href="https://wa.me/918743940556"
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp />
                Chat Now
              </a>

            </div>

            <div className="chat-image">

              <img
                src="https://images.unsplash.com/photo-1556740749-887f6717d7e4?q=80&w=1200&auto=format&fit=crop"
                alt="chat"
              />

            </div>

          </div>

        </div>

      </section>

      {/* FAQ */}

<section className="tm-section">

  <div className="container">

    <div className="section-title">
      <h2>Frequently Asked Questions</h2>
    </div>

    <div className="faq-grid">

      {/* FAQ 1 */}

      <div className="faq-card">

        <input type="checkbox" id="faq1" />

        <label htmlFor="faq1" className="faq-question">

          What is a Trademark Class?

          <span>⌄</span>

        </label>

        <div className="faq-answer">

          <p>
            Trademark Registry has classified goods and services under
            45 different classes. Your trademark application must be
            filed under the correct class.
          </p>

        </div>

      </div>

      {/* FAQ 2 */}

      <div className="faq-card">

        <input type="checkbox" id="faq2" />

        <label htmlFor="faq2" className="faq-question">

          What is the validity of Trademark?

          <span>⌄</span>

        </label>

        <div className="faq-answer">

          <p>
            Trademark registration is valid for 10 years and can be
            renewed again after expiry.
          </p>

        </div>

      </div>

      {/* FAQ 3 */}

      <div className="faq-card">

        <input type="checkbox" id="faq3" />

        <label htmlFor="faq3" className="faq-question">

          How long does Trademark registration take?

          <span>⌄</span>

        </label>

        <div className="faq-answer">

          <p>
            Trademark filing can be completed within a few working days,
            while full registration may take several months.
          </p>

        </div>

      </div>

      {/* FAQ 4 */}

      <div className="faq-card">

        <input type="checkbox" id="faq4" />

        <label htmlFor="faq4" className="faq-question">

          Can foreign companies apply for Trademark?

          <span>⌄</span>

        </label>

        <div className="faq-answer">

          <p>
            Yes, foreign entities and international businesses can also
            apply for trademark registration in India.
          </p>

        </div>

      </div>

    </div>

  </div>

</section>


      {/* TESTIMONIAL SECTION */}

<section className="testimonial-section">

  <div className="container">

    {/* HEADING */}

    <div className="section-title">

      <h2>What our users have to say</h2>

      <p>
        Trusted by startups, businesses and entrepreneurs across India
      </p>

    </div>

    {/* TESTIMONIAL GRID */}

    <div className="testimonial-grid">

      {/* CARD 1 */}

      <div className="testimonial-card">

        <div className="testimonial-top">

          <img
            src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=400&auto=format&fit=crop"
            alt="user"
          />

          <div className="testimonial-user">

            <h3>Rohit Sharma</h3>

            <span>Startup Founder</span>

          </div>

        </div>

        <div className="testimonial-stars">
          ★★★★★
        </div>

        <p>
          LegalAxis made our trademark registration process extremely smooth.
          Their support team guided us at every step and provided regular updates.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="testimonial-card">

        <div className="testimonial-top">

          <img
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=400&auto=format&fit=crop"
            alt="user"
          />

          <div className="testimonial-user">

            <h3>Priya Verma</h3>

            <span>Business Owner</span>

          </div>

        </div>

        <div className="testimonial-stars">
          ★★★★★
        </div>

        <p>
          Very professional service and excellent communication.
          The legal experts were knowledgeable and responsive throughout.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="testimonial-card">

        <div className="testimonial-top">

          <img
            src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=400&auto=format&fit=crop"
            alt="user"
          />

          <div className="testimonial-user">

            <h3>Aman Singh</h3>

            <span>Entrepreneur</span>

          </div>

        </div>

        <div className="testimonial-stars">
          ★★★★★
        </div>

        <p>
          Highly recommended for startup legal services.
          Fast process, transparent pricing and amazing support team.
        </p>

      </div>

    </div>

  </div>

</section>


      {/* CLIENTS */}

      <section className="clients-section">

        <div className="container">

          <div className="section-title">

            <h2>Our Clients</h2>

          </div>

          <div className="client-grid">

            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/7b/Ola_Cabs_logo.svg"
              alt="ola"
            />

            <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/0c/Shadowfax_Logo.png"
              alt="shadowfax"
            />

            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/5d/Zoomcar_Logo.png"
              alt="zoomcar"
            />

            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/7c/Rivigo_Logo.png"
              alt="rivigo"
            />

          </div>

        </div>

      </section>

    </div>
  );
}

export default TrademarkPage;